import { Link } from 'react-router-dom';
import Seo from '@/components/base/Seo';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import { testimonials } from '@/mocks/testimonials';

const values = [
  {
    icon: 'ri-compass-3-line',
    title: '网站定位',
    text: '歪歪漫画是专注韩国歪歪漫画恶搞反转、神展开、脑洞魔性、爆笑的漫画合集平台。我们筛掉糟粕、精选笑点，让每一个点进来的人都立刻进入快乐状态。',
  },
  {
    icon: 'ri-rocket-2-line',
    title: '发展理念',
    text: '从「每天有更新」到「分类找得到」，再到「越看越上头」，我们始终把阅读体验放在第一位。未来会持续扩充题材、扶持原创作者，让快乐内容源源不断。',
  },
  {
    icon: 'ri-sparkling-line',
    title: '内容原则',
    text: '坚持原创优先、拒绝低质搬运；分类清晰、标签精准；每日定时上新、绝不拖延。我们希望每一部作品都经得起「歪歪一下」的标准检验。',
  },
];

export default function About() {
  const orgLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '歪歪漫画',
    description: '韩国歪歪漫画恶搞反转神展开脑洞魔性爆笑漫画合集平台',
    url: typeof window !== 'undefined' ? window.location.origin : '',
    contactPoint: { '@type': 'ContactPoint', email: 'hello@waiwaicomic.com', contactType: 'customer service' },
  };

  return (
    <>
      <Seo
        title="关于我们 - 歪歪漫画 韩国歪歪漫画恶搞反转爆笑漫画平台"
        description="了解歪歪漫画的品牌介绍、网站定位、发展理念与内容原则。我们专注韩国歪歪漫画恶搞反转、神展开、脑洞魔性、爆笑漫画，每日更新热门作品。"
        keywords="歪歪漫画,关于我们,韩国歪歪漫画,爆笑漫画平台"
        canonicalPath="/about"
        jsonLd={[orgLd]}
      />
      <Navbar />
      <main className="min-h-screen bg-background-100 pt-16 md:pt-18">
        <div className="container-page py-8 md:py-10">
          <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '关于我们' }]} />

          <div className="mt-6 overflow-hidden rounded-3xl bg-primary-500">
            <div className="relative bg-cover bg-center px-6 py-14 md:px-10 md:py-20">
              <div className="absolute inset-0 bg-foreground-950/20" aria-hidden="true" />
              <div className="relative z-10 max-w-2xl">
                <span className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-4 py-1.5 text-sm font-bold text-foreground-950">
                  <i className="ri-emotion-laugh-line" aria-hidden="true" />
                  关于歪歪漫画
                </span>
                <h1 className="mt-5 text-3xl text-background-50 md:text-5xl">把全网的快乐，装进一个网站</h1>
                <p className="mt-4 text-base leading-relaxed text-background-100">
                  歪歪漫画致力于成为中文世界里「最好笑的漫画入口」。无论你想看恶搞反转还是脑洞魔性，在这里都能一键开追。
                </p>
              </div>
            </div>
          </div>

          <div className="mt-8 grid gap-4 md:grid-cols-3">
            {values.map((v) => (
              <article key={v.title} className="rounded-2xl border border-background-200/70 bg-background-50 p-6">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                  <i className={`${v.icon} text-2xl`} aria-hidden="true" />
                </span>
                <h2 className="mt-4 font-heading text-xl text-foreground-950">{v.title}</h2>
                <p className="mt-3 text-sm leading-relaxed text-foreground-700">{v.text}</p>
              </article>
            ))}
          </div>

          <section className="mt-8 rounded-3xl border border-background-200/70 bg-background-50 p-6 md:p-8">
            <h2 className="font-heading text-2xl text-foreground-950">我们的坚持</h2>
            <div className="mt-6 grid gap-5 sm:grid-cols-2">
              {[
                ['每日双更', '每天 10:00 与 18:00 定时上新，追更从不缺席。'],
                ['免费阅读', '全站免费、无门槛，快乐不设限。'],
                ['分类清晰', '恶搞、反转、神展开、脑洞、魔性、爆笑，六大分类秒定位。'],
                ['扶持原创', '为优秀创作者提供签约与流量扶持，让好内容被看见。'],
              ].map(([t, d]) => (
                <div key={t} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-900">
                    <i className="ri-check-line text-sm" aria-hidden="true" />
                  </span>
                  <div>
                    <h3 className="text-sm font-bold text-foreground-950">{t}</h3>
                    <p className="mt-1 text-sm text-foreground-700">{d}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="mt-8 rounded-3xl border border-background-200/70 bg-background-50 p-6 md:p-8">
            <h2 className="font-heading text-2xl text-foreground-950">读者怎么说</h2>
            <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
              {testimonials.map((t) => (
                <figure key={t.name} className="rounded-2xl bg-background-100 p-4">
                  <figcaption className="flex items-center gap-2">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-200 text-base">{t.emoji}</span>
                    <div>
                      <p className="text-sm font-bold text-foreground-950">{t.name}</p>
                      <p className="text-xs text-foreground-600">{t.role}</p>
                    </div>
                  </figcaption>
                  <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">“{t.content}”</blockquote>
                </figure>
              ))}
            </div>
          </section>

          <section className="mt-8 rounded-3xl border border-background-200/70 bg-background-50 p-6 md:p-8">
            <h2 className="font-heading text-2xl text-foreground-950">联系我们</h2>
            <p className="mt-2 text-sm text-foreground-700">
              对作品有建议、想合作投稿，或只是想聊聊天，都欢迎来找我们。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-3">
              <Link to="/contact" className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600">
                进入联系页面
              </Link>
              <span className="inline-flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-mail-line text-primary-600" aria-hidden="true" />
                hello@waiwaicomic.com
              </span>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}